@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.support
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.dto.core.MultiLingualTextDto

class SupportIssueDto(
    val id: KmmLong? = null,
    val categoryId: KmmLong,
    val title: MultiLingualTextDto,
    val body: MultiLingualTextDto,
    val isActive: Boolean,
    val createdOn: DateTimeDto? = null
)